/* istanbul ignore file */

import type { Analytics } from '@firebase/analytics';
import {
  logEvent as firebaseLogEvent,
  setUserId as firebaseSetUserId,
  getAnalytics,
} from '@firebase/analytics';

import { firebaseApp, firebase_analytics_enable } from './app';

let analytics: Analytics;

if (firebase_analytics_enable) {
  analytics = getAnalytics(firebaseApp);
}

/**
 * Sends event to Google Analytics.
 *
 * @param event - Event name.
 * @param parameters - Event parameters.
 */
export function logEvent(event: string, parameters?: Record<string, any>) {
  if (firebase_analytics_enable) {
    firebaseLogEvent(analytics, event, parameters);
  }
}

/**
 * Sets user id in Google Analytics.
 *
 * @param userId - User id.
 */
export function setUserId(userId: string) {
  if (firebase_analytics_enable) {
    firebaseSetUserId(analytics, userId);
  }
}
